import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import BarcodeDisplay from "./BarcodeDisplay";
import QRCodeDisplay from "./QRCodeDisplay";

const MedicineLabelPreview = ({ barcode, name, category, price, expiry }) => {
  if (!barcode) return null;

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px dashed rgba(25,118,210,0.35)",
        bgcolor: "#fff",
        textAlign: "center",
      }}
    >
      <Typography variant="subtitle1" fontWeight={700} mb={0.5}>
        {name || barcode}
      </Typography>
      {category && (
        <Typography variant="caption" color="text.secondary" display="block">
          {category}
        </Typography>
      )}
      {price != null && price !== "" && (
        <Typography variant="caption" color="text.secondary" display="block">
          {price}
        </Typography>
      )}
      {expiry && (
        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
          {expiry}
        </Typography>
      )}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        useFlexGap
      >
        <BarcodeDisplay value={barcode} />
        <QRCodeDisplay value={barcode} size={96} />
      </Stack>
      <Typography variant="caption" color="text.secondary" mt={1} display="block">
        {barcode}
      </Typography>
    </Box>
  );
};

export default MedicineLabelPreview;
